import {
    HTMLAttributes,
    useState,
    ReactElement,
} from "react";
import { Cancel, DangerSquare, SearchNormal, Star } from "../../assets";
import LoadingSpinner from "./loading_spinner";
import CustomModal from "./modal";

interface Props extends HTMLAttributes<HTMLElement> {
    value?: any;
    title?: string,
    onChange?: any;
    myStyle?: string;
    lable?: string;
    displayEmpty?: boolean;
    placeholder?: string;
    icon?: ReactElement;
    iconBorder?: boolean;
    hasNotice?: string;
    item?: any;
    isRequired?: boolean;
    search?: any;
    error?: string;
    loading?: boolean;
    contentLoading?: boolean;
}

export function CustomSearch({ value, onChange, title, myStyle, lable, error, displayEmpty, placeholder, icon, loading, hasNotice, isRequired, onClick, item, search, contentLoading }: Props): ReactElement {

    const [showDropDown, setShowDropDown] = useState(false);
    const [str, setStr] = useState("");

    const [openModal, setOpenModal] = useState(false); // مدیریت نمایش مدال

    const handleOnClick = (item: any) => {
        onChange && onChange(item);
        setShowDropDown(false)
    }
    return (
        <div className={`${myStyle && myStyle} ${value === undefined ? "" : "checked"} custom-search`}>

            <>
                {lable &&
                  <>
                    {contentLoading ?
                        <div className="content-loading input-loading-lable">
                        </div>
                        :
                    <label className="custom-search-lable">
                        {contentLoading ? <div className="icontent-loading"></div> :
                            <>
                                {isRequired && <img src={Star} alt="هامرز"/>}  {lable} 
                                {hasNotice && ( 
                                <img
                                    src={DangerSquare}
                                    alt="هامرز"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setOpenModal(true)} // باز کردن مدال
                                />
                             )} 
                            </>

                        }
                    </label>
}
</>
}



            </>


            {contentLoading ? <div className="content-loading w-100">
            </div> :

                <div className={`${error ? "border-danger" : ""} custom-search-content`} onClick={() => setShowDropDown(true)} >
                    <div className="three-dots ">
                        <span className="custom-search-icon-border">
                            {icon}

                        </span>
                        <span className="custom-search-placeholder">
                            {value ? title : placeholder}
                        </span>

                    </div>
                    <div className="arrow arrow-up"></div>
                </div>
            }
            {error &&
                <label className="custom-search-error">
                    {error}
                </label>
            }
            {showDropDown === true ? ( 
                <div className="custom-search-list">
                    <div className="search-container">
                    <input
                            placeholder="جستجو کنید"
                            value={str}
                            onChange={(e) => {

                                let value = e.target.value;
                                setStr(value);

                                if (value?.trim().length > 2 )

                                    search(value)
                            }}
                        />
                        {loading ?
                            <div className="handle-loading-btn search-container-icon">
                                <LoadingSpinner />
                            </div>
                            : <img src={SearchNormal} alt="هامرز"  className="search-container-icon" />}

                    </div>
                    {item && item?.length > 0 ?
                        <ul className="ul-list">
                            {item && item.length > 0 && item?.map((item: any, index: any) => (
                                <li key={index} className="custom-search-list-item" onClick={() => handleOnClick(item)}>
                                    <a> {item.title}</a>
                                </li>
                            ))
                            }
                        </ul>
                        :
                            <>
                            {!loading && 
                            
                            <p className="desc"> {str.length < 3 ? "برای جستجو حداقل سه کاراکتر وارد کنید" : "موردی یافت نشد"} </p> 
                            
                            }
                            </>
                    }
                </div>
            ) : (null)
            }
            {showDropDown ? (<div className='overlay' onClick={() => setShowDropDown(false)} />) : null}
                 {/* مدال */}
            <CustomModal myStyle="custom-input-modal" openModal={openModal} onClose={() =>setOpenModal(!openModal )}>
          <>
            <div className="custom-modal-main-title hide-desktop">
              <h1 className="title">
              {lable}              </h1>
              <Cancel myStyle="ps-2 " width="20" height="20" color="#000000" onClick={() =>setOpenModal(!openModal )} />
            </div>
            <div className="filter-selected">
              <div>
                <span className="text ml-50 hide-mobile bold">
                {lable}
                </span>{" "}
              </div>
              <Cancel myStyle="hide-mobile cursor-pointer" onClick={() =>setOpenModal(!openModal )} />
            </div>
            
            <h2 className="custom-input-modal-info mt-33">
           {hasNotice}
            </h2>
             
          </>
        </CustomModal>
        </div >
    );
}

export default CustomSearch;

